import React from 'react';
import ReactMarkdown from 'react-markdown';

import { LongFormTextModalContext } from '../../utils/contexts';
import { Modal, Content, Container } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';

export default function LongFormTextModal(props) {
	return(
		<LongFormTextModalContext.Consumer>
			{
				({ title, markdown, isOpen, setIsOpen }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

					return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
						<Modal>
							<Header onCloseClick={() => setIsOpen(false)} />
							<Content className="pad scrollable">
								<h3>{title}</h3>
								<ReactMarkdown source={markdown} />
							</Content>
						</Modal>
					</Container>
        }
			}
		</LongFormTextModalContext.Consumer>
	);
}